console.log('register service worker..')

window.addEventListener('load', () => {
    registerSW();
});

// Register the Service Worker 
async function registerSW() {
    if ('serviceWorker' in navigator) {
        try {
            await navigator
                .serviceWorker
                .register('/pwa/static/service-worker.js?100', {scope: '/pwa/'});
        }
        catch (e) {
            console.log('SW registration failed');
        }
    }
}
